import {BusinessFeeNegotiationStatus} from '@afriex/core/domain/enums';

/** Badge colour for a negotiation status, on the house status scheme. */
export const negotiationStatusColorScheme = (
  status?: BusinessFeeNegotiationStatus,
): string => {
  switch (status) {
    case BusinessFeeNegotiationStatus.PendingAdmin:
      return 'pending';
    case BusinessFeeNegotiationStatus.PendingBusiness:
      return 'refunded';
    case BusinessFeeNegotiationStatus.Accepted:
      return 'successful';
    case BusinessFeeNegotiationStatus.Rejected:
      return 'failed';
    default:
      return 'gray';
  }
};
